import moment from "moment";
import React, { useRef } from "react";
import Table from "../../components/table/table";
import { Link, useSearchParams } from "react-router-dom";
import { useAppContext } from "../../context/app.context";
import { showToast } from "../../utils/utils";

export default function MissionslistPage() {
  const { appInfos } = useAppContext();
  const csvRows = [
    { key: "_id", label: "id" },
    { key: "status", label: "Statut" },
    { key: "idUser", label: "Nom de l'entreprise" },
    { key: "idJobbeur", label: "Jobbeur" },
    { key: "remuneration", label: "Rémunération" },
    { key: "zone", label: "zone" },
    { key: "dateDebut", label: "Date Début" },
    { key: "dateFin", label: "Date fin" },
    { key: "created_at", label: "Date de création" },
  ];
  const tableRef: any = useRef();

  const [searchParams] = useSearchParams();
  const jobbeur = searchParams.get("jobbeur");
  const entreprise = searchParams.get("entreprise");
  const failed = searchParams.get("failed");
  const failschedule = searchParams.get("failschedule");
  const columns = [
    {
      accessorKey: "status",
      header: "Statut",
      filterVariant: "multi-select",
      filterSelectOptions: [
        { label: "Terminée", value: "terminée" },
        { label: "En attente", value: "enattente" },
        { label: "A venir", value: "avenir" },
        { label: "Annulée", value: "annulee" },
        { label: "En attente de paiement", value: "payment" },
      ],
      size: 30,
      Cell: ({ cell }: any) => {
        const tag = statusMission(cell.row.original.status);
        return <span className={"badge " + tag.class}>{tag.title}</span>;
      },
    },
    {
      accessorKey: "transfert",
      header: "Transfert",
      filterVariant: "multi-select",
      filterSelectOptions: [
        { label: "Payée", value: "done" },
        { label: "Non payée", value: "impaid" },
        { label: "En attente", value: "waiting" },
        { label: "Annulée", value: "canceled" },
      ],
      Cell: ({ cell }: any) => {
        const transfert = cell.row.original.transfert;
        return transfert == "done" ? (
          <span className={"badge badge-success"}>{"Payée"}</span>
        ) : transfert == "canceled" ? (
          <span className={"badge badge-danger"}>{"Annulée"}</span>
        ) : transfert == "waiting" ? (
          <span className={"badge badge-warning"}>{"En attente"}</span>
        ) : (
          <>
            <span
              onClick={() => {
                if (appInfos.user.role != "admin")
                  return showToast("Accès refusé : vous ne pouvez pas effectuer un transfert.");
                tableRef.current.onPay(cell.row.original);
              }}
              style={{ cursor: "pointer" }}
              className={"badge badge-blue"}
            >
              {"Lancer le transfert"}
            </span>
          </>
        );
      },
    },
    {
      accessorKey: "idUser.NomEntreprise",
      header: "Nom de l'entreprise",
    },
    {
      accessorKey: "idJobbeur.nom",
      header: "Jobbeur",
    },
    {
      accessorFn: (originalRow: any) => +originalRow.remuneration,
      accessorKey: "remuneration",
      header: "Rémunération",
      filterVariant: "range",
    },
    {
      accessorKey: "zone.name",
      header: "Zone",
    },
    {
      accessorFn: (originalRow: any) => new Date(originalRow.dateDebut),
      header: "Date Début",
      filterVariant: "date-range",
      sortingFn: "datetime",
      Cell: ({ cell }: any) => new Date(+cell.getValue()).toLocaleString("fr-FR", { timeZone: "Europe/Paris" }),
      type: "date",
      size: 40,
    },
    {
      accessorFn: (originalRow: any) => new Date(originalRow.dateFin),
      header: "Date Fin",
      filterVariant: "date-range",
      sortingFn: "datetime",
      Cell: ({ cell }: any) => new Date(+cell.getValue()).toLocaleString("fr-FR", { timeZone: "Europe/Paris" }),
      type: "date",
      size: 40,
    },
    {
      accessorFn: (originalRow: any) => new Date(originalRow.created_at),
      header: "Date de création",
      filterVariant: "date-range",
      sortingFn: "datetime",
      Cell: ({ cell }: any) => new Date(+cell.getValue()).toLocaleString("fr-FR", { timeZone: "Europe/Paris" }),
      type: "date",
    },
    {
      accessorKey: "facture",
      header: "Factures",
      size: 30,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ cell }: any) => {
        const id = cell.row.original._id;
        const status = cell.row.original.status;
        const disabled = status != "terminée" && status != "annulee";
        return (
          <Link
            to={"/factures?mission=" + id}
            style={{ pointerEvents: disabled ? "none" : "auto" }}
            // disabled={cell.row.original.status != "terminée"}
            className={`btn btn-secondary btnsmall ${disabled ? "btn-secondary-disabled" : ""}`}
            title="Voir"
          >
            <span>Voir</span>
          </Link>
        );
      },
    },
    {
      accessorKey: "notemission",
      header: "Note mission",
      enableColumnFilter: false,
      enableSorting: false,
      size: 30,
      Cell: ({ cell }: any) => {
        const id = cell.row.original._id;
        const disabled = cell.row.original.status != "terminée";
        return (
          <Link
            to={"/notes/missions?mission=" + id}
            style={{ pointerEvents: disabled ? "none" : "auto" }}
            className={`btn btn-secondary btnsmall ${disabled ? "btn-secondary-disabled" : ""}`}
            title="Voir"
          >
            <span>Voir</span>
          </Link>
        );
      },
    },
    {
      accessorKey: "notejobbeur",
      header: "Note Jobbeur",
      size: 30,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ cell }: any) => {
        const id = cell.row.original._id;
        const disabled = cell.row.original.status != "terminée";
        return (
          <Link
            to={"/notes/jobbeur?mission=" + id}
            style={{ pointerEvents: disabled ? "none" : "auto" }}
            className={`btn btn-secondary btnsmall ${disabled ? "btn-secondary-disabled" : ""}`}
            title="Voir"
          >
            <span>Voir</span>
          </Link>
        );
      },
    },
  ];
  return (
    <>
      <Table
        mapData={getStatus}
        showExport
        ref={tableRef}
        csvRows={csvRows}
        dataUrl={
          "missions" +
          (failschedule && failed
            ? "?failed=true&failschedule=true"
            : failed
              ? "?failed=true"
              : (jobbeur ? "?jobbeur=" + jobbeur : "") +
                (entreprise ? "?entreprise=" + entreprise : failschedule ? "?failschedule=true" : ""))
        }
        columns={columns}
        permission="missions"
        title="Missions"
      />
    </>
  );
}
export function statusMission(status: any) {
  if (status == "encours") return { title: "En cours", class: "badge-blue" };
  if (status == "enattente") return { title: "En attente", class: "badge-warning" };
  if (status == "payment") return { title: "En attente de paiement", class: "badge-warning" };
  if (status == "avenir") return { title: "A venir", class: "badge-violet" };
  if (status == "annulee") return { title: "Annulée", class: "badge-danger" };
  if (status == "terminée") return { title: "Terminée", class: "badge-success" };
  return { title: "", class: "" };
}
export function getStatus(elt: any) {
  let status = elt.status;
  if (status == "payment" && moment(elt.dateDebut).isAfter(new Date())) {
    status = "payment";
  } else if (status == "payment" && new Date(elt.dateDebut).getTime() < new Date().getTime()) {
    status = "annulee";
  } else if (status == "annulee") {
    status = "annulee";
  } else if ((!elt.idJobbeur || elt.idJobbeur == null) && moment(elt.dateFin).isBefore(new Date())) {
    status = "annulee";
  } else if (elt.status === "enattente" && moment(elt.dateDebut).isAfter(new Date())) {
    status = "enattente";
  } else if (
    elt?.idJobbeur?._id &&
    moment(elt.dateDebut).isBefore(new Date()) &&
    moment(elt.dateFin).isAfter(new Date())
  ) {
    status = "encours";
  } else if (
    !elt?.idJobbeur?._id &&
    moment(elt.dateDebut).isBefore(new Date()) &&
    moment(elt.dateFin).isAfter(new Date())
  ) {
    status = "annulee";
  } else if (moment(elt.dateDebut).isAfter(new Date())) {
    status = "avenir";
  } else if (moment(elt.dateFin).isBefore(new Date())) status = "terminée";
  elt.status = status;
  if (elt.idJobbeur) elt.idJobbeur.nom = (elt?.idJobbeur?.prenom || "") + " " + (elt?.idJobbeur?.nom || "");
  elt.transfert =
    elt.idTransaction && elt.idTransaction != "" && status == "terminée"
      ? "done"
      : status == "terminée"
        ? "impaid"
        : status == "annulee"
          ? "canceled"
          : "waiting";
  return elt;
}
